import { Link } from 'react-router-dom';

const CAT_LABEL = {
  notice: 'Notice',
  story: 'Story',
  event: 'Event',
  achievement: 'Achievement',
  in_memoriam: 'In Memoriam',
};

const formatDate = (iso, opts) => {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-GB', opts || { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return '';
  }
};

const PLACEHOLDER = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 9"><rect width="16" height="9" fill="%231d4d3a"/></svg>';

/**
 * Public-site news card.
 *
 * variant:
 *   "default"   the .news-card pattern from news.html / achievements.html
 *               (image-on-top, no background tint, hover lifts).
 *   "whatson"   the .whatson-card pattern from the homepage's "What's on"
 *               section (cream tint, image with object-fit, smaller).
 *   "featured"  same as default but renders excerpt + larger headline.
 */
export function NewsCard({ item, variant = 'default' }) {
  const href = `/news/${item.slug}`;
  const cat = CAT_LABEL[item.category] || item.category || 'News';
  const date = formatDate(item.publishedAt || item.createdAt);

  if (variant === 'whatson') {
    return (
      <Link to={href} className="whatson-card" data-cat={item.category}>
        <div className="img" style={{ backgroundImage: `url('${item.heroImage || PLACEHOLDER}')` }} aria-hidden="true" />
        <div className="body">
          <div className="meta">
            <span className="cat">{cat}</span>
            {date && <span>{date}</span>}
          </div>
          <h3>{item.title}</h3>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={href}
      className={`news-card${variant === 'featured' ? ' featured' : ''}`}
      data-cat={item.category}
      style={{ display: 'flex', flexDirection: 'column', textDecoration: 'none' }}
    >
      <div className="photo" style={{ backgroundImage: `url('${item.heroImage || PLACEHOLDER}')` }} aria-hidden="true" />
      <div className="body">
        <div className="meta">
          <span className="tag">{cat}</span>
          <span className="dot" />
          {date && <span>{date}</span>}
        </div>
        <h3>{item.title}</h3>
        {item.excerpt && <p>{item.excerpt}</p>}
      </div>
    </Link>
  );
}
